import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',
    boxSizing: 'border-box',
    paddingBottom: '1.5rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  question: {
    textAlign: 'center',
    marginBottom: '1.5rem',

    '& > div:not(:last-child)': {
      marginBottom: '0.25rem'
    }
  },

  options: {
    display: 'flex',
    justifyContent: 'space-evenly',

    '& .button': {
      display: 'flex',
      alignItems: 'center',
      borderRadius: '200rem',
      padding: '10px 30px',
      backgroundColor: '#EBEEEF',
      fontSize: theme.size.sm,
      cursor: 'pointer',
      marginBottom: '0.5rem'
    }
  },

  buttonText: {
    textAlign: 'center',
    fontSize: theme.size.sm
  },

  iconNo: {
    marginRight: '0.5rem',
    width: 'auto',
    borderRadius: '50%',
    boxSizing: 'border-box',
    fontSize: theme.size.base,
    color: 'red'
  },

  iconYes: {
    marginRight: '0.5rem',
    width: 'auto',
    borderRadius: '50%',
    boxSizing: 'border-box',
    fontSize: theme.size.base,
    color: 'green'
  }
}))

export default useStyles
